import { View } from "react-native";
import RoundedButton from "src/components/RoundedButton";
import native from "src/constants/native";
import hasValidCommunityAccess from "src/helpers/communityHelpers/hasValidCommunityAccess";
import parseV0TemplateUrl from "src/helpers/parseV0TemplateUrl";
import useRouter from "src/hooks/useRouter";
import useStyle from "src/hooks/useStyle";
import { SearchCommunityType } from "src/screens/(internal)/SearchModal/types";
import { color } from "src/styles";
import { radiusSmall } from "src/styles/radius";
import { paddingMedium, paddingSmall } from "src/styles/spacing";
import { Image, Link, Text } from "src/swsh-native";
import { SEARCH_COMMUNITY_BASE_SIZE, SEARCH_COMMUNITY_SPACING } from "../constants";

const ImagePadding = paddingMedium;

const SearchCommunityItem = ({ item }: { item: SearchCommunityType }) => {
	const { theme } = useStyle();
	const href = native
		? item.communityId
			? `/group/${item.communityId}`
			: null
		: item.refCode
			? `/group/${item.refCode}`
			: null;
	const url = parseV0TemplateUrl({
		readUrl: item.thumbnail?.readUrl,
		aspectRatio: "1x1",
		strategy: "cover",
		size: "sm",
	});
	const router = useRouter();
	const hasCommunityAccess = hasValidCommunityAccess(item);

	if (!href || !url) return null;
	return (
		<Link
			testID="SearchCommunity"
			// Touchable inside a link is wack
			// Theoretically this could be fixed to make the background still clickable, but it's not worth the effort since link pasting is almost never used
			// (It's also debatable whether the card should be clickable at all, since the join button is there)
			viewOnly={!hasCommunityAccess}
			style={[
				{
					width: SEARCH_COMMUNITY_BASE_SIZE,
					overflow: "hidden",
					backgroundColor: color.BackgroundCard[theme],
					paddingTop: ImagePadding,
					paddingHorizontal: ImagePadding,
					borderRadius: radiusSmall,
					marginHorizontal: SEARCH_COMMUNITY_SPACING,
					paddingBottom: paddingMedium,
				},
			]}
			href={href}
		>
			<Image
				alt={"Group Thumbnail"}
				src={url}
				dim={{
					width: SEARCH_COMMUNITY_BASE_SIZE - ImagePadding * 2,
					height: SEARCH_COMMUNITY_BASE_SIZE - ImagePadding * 2,
				}}
				style={{
					borderRadius: radiusSmall,
				}}
			/>
			<View
				style={{
					marginTop: paddingMedium,
				}}
			>
				<Text testID="Name" semibold numberOfLines={1}>
					{item.name}
				</Text>
				{hasCommunityAccess ? (
					<Text color="TextLight" numberOfLines={1} style={{ marginTop: paddingSmall }}>
						{Math.max(item.numGatherings ?? 0, 0)} albums
					</Text>
				) : (
					<RoundedButton
						containerStyle={{
							marginTop: paddingMedium,
							zIndex: 1,
						}}
						sizeVariant="Flex"
						onPress={() => {
							router.push(`/group/${item.refCode}?join=true`);
						}}
					>
						Join
					</RoundedButton>
				)}
			</View>
		</Link>
	);
};
export default SearchCommunityItem;
